var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('h2',[_vm._v(_vm._s(_vm.$t('create_energy_price_set')))]),_c('energy-price-set-form',{on:{"saved":function($event){return _vm.energyPriceSetCreated($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }